
import { useEffect } from 'react';
import { withSelect } from '@wordpress/data';
// Settings Components
import { tabController } from '../../Components/utils/functions';

import Style from './Style';
import Products from './Products';
import Settings from './BlockSettings/Settings';

const Edit = props => {
    const { className, attributes, setAttributes, clientId, isSelected, allCategories } = props;
    useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId
    useEffect(() => tabController(), [isSelected]);

    return <>
        <Settings attributes={attributes} setAttributes={setAttributes} allCategories={allCategories} />

        <div className={className} id={`bpwpsb-product-swiper-${clientId}`}>
            <Style attributes={attributes} id={`bpwpsb-product-swiper-${clientId}`} />
            <Products attributes={attributes} />
        </div>
    </>;
};

export default withSelect(select => {
    return {
        allCategories: select('core').getEntityRecords('taxonomy', 'product_cat', { per_page: -1 })
    };
})(Edit);